<template>
  <div>
    <o-pager
      :button="$t('general.loadMore')"
      empty=""
      header-class="flex justify-between items-center mb-4 border-b pb-2"
      class="mb-16"
      :list="pager"
    >
      <template #default="{data}">
        <div v-for="(group, key) in split(data)" :key="key" class="mb-8">
          <p v-if="group.label" class="text-xs mb-3 tracking-wider opacity-60 uppercase">
            {{ key }}
          </p>
          <div>
            <div v-if="group.grid.length" class="flex items-start flex-wrap gap-3 mb-8">
              <grid
                v-for="upload in group.grid"
                :key="upload.idPhoto"
                :upload="upload"
                @click="handlePreview(upload.index)"
                @delete="handleDelete(upload)"
              />
            </div>

            <div v-if="group.list.length" class="overflow-hidden p-2 md:p-2 h-full bg-white dark:bg-gray-900 rounded-2xl mb-4 border">
              <table class="w-full table-auto">
                <tbody>
                  <list
                    v-for="upload in group.list"
                    :key="upload.idPhoto"
                    :upload="upload"
                    class="pb-2"
                    @click="handlePreview(upload.index)"
                    @delete="handleDelete(upload)"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </o-pager>

    <preview
      ref="preview"
      :data="pager.items"
      @delete="(upload) => handleDelete(upload)"
      @save="handleSaveSuccess"
    />

    <delete-dialog
      ref="deleteDialog"
      @success="handleDeleteSuccess"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useNuxtApp } from '#app'

import DeleteDialog from '../actions/Delete.vue'
import Grid from './Grid.vue'
import List from './List.vue'
import Preview from './Preview.vue'

import { OPager } from '@/components/elements'

const { $date } = useNuxtApp()

interface Props {
  pager: Record<string, any>
  sort?: boolean
  view?: string
}

const props = withDefaults(defineProps<Props>(), {
  sort: false,
  view: 'combo',
})

const preview = ref<any>()
const deleteDialog = ref<any>()

onMounted(() => {
  props.pager.load()
})

function split (data: any[]) {
  return data.reduce((acc: any, upload: any, index: number) => {
    const date = props.sort ? $date.format(upload.created * 1000, 'MMMM yyyy') : 0

    if (!acc[date]) {
      acc[date] = {
        label: date,
        list: [],
        grid: [],
      }
    }

    upload.index = index

    if (props.view === 'combo') {
      if (upload.isDataTypePhoto) {
        acc[date].grid.push(upload)
      } else if (upload.isDataTypeDocument) {
        acc[date].list.push(upload)
      }
    }

    if (props.view === 'list') {
      acc[date].list.push(upload)
    }

    if (props.view === 'grid') {
      acc[date].grid.push(upload)
    }

    return acc
  }, {})
}

function handlePreview (index: number) {
  preview.value.open(index)
}

function handleDelete (upload: any) {
  deleteDialog.value.open(upload)
}

function handleDeleteSuccess () {
  props.pager.reload()
  preview.value.index = null
}

function handleSaveSuccess () {
  props.pager.reload()
}
</script>
